// extracted by mini-css-extract-plugin
module.exports = {"content":"cartDrawer_content__2dIMZ","items":"cartDrawer_items__-7QNa","footer":"cartDrawer_footer__3OpQH"};